const MuiButtonOverrides = {
  MuiButton: {
    defaultProps: {
      variant: 'contained',
      disableElevation: true,
      disableRipple: true
    },
    styleOverrides: {
      root: _ref => {
        let {
          theme,
          ownerState
        } = _ref;
        return {
          borderRadius: 'initial',
          textTransform: 'initial',
          letterSpacing: 'initial',
          transition: theme.transitions.create(['box-shadow', 'color', 'background-color', 'border-color']),
          ...theme.typography.body02,
          ...(ownerState.size === 'medium' && {
            padding: theme.spacing(1.25, 1.5)
          }),
          ...(ownerState.size === 'small' && {
            padding: theme.spacing(0.75, 1.5)
          }),
          '&.Mui-focusVisible': {
            outline: `2px ${theme.palette.orangeBase} solid`
          }
        };
      },
      outlined: _ref2 => {
        let {
          theme,
          ownerState
        } = _ref2;
        return {
          color: theme.palette.blueBase,
          borderColor: 'transparent',
          ':hover': {
            borderColor: 'transparent',
            backgroundColor: 'transparent',
            color: theme.palette.blue60
          },
          ':active, &.Mui-active': {
            color: theme.palette.blue70
          },
          ':disabled': {
            borderColor: 'transparent'
          },
          ...(ownerState.color === 'error' && {
            color: theme.palette.redBase,
            ':hover': {
              color: theme.palette.red60,
              borderColor: 'transparent',
              backgroundColor: 'transparent'
            },
            ':active, &.Mui-active': {
              color: theme.palette.red70
            }
          })
        };
      },
      contained: _ref3 => {
        let {
          theme,
          ownerState
        } = _ref3;
        return {
          ...(ownerState.color === 'primary' && {
            backgroundColor: theme.palette.blueBase,
            ':hover': {
              backgroundColor: theme.palette.blue60
            },
            ':active, &.Mui-active': {
              backgroundColor: theme.palette.blue70
            },
            ':disabled': {
              color: theme.palette.white,
              backgroundColor: theme.palette.blue20
            }
          }),
          ...(ownerState.color === 'error' && {
            color: theme.palette.white,
            backgroundColor: theme.palette.redBase,
            ':hover': {
              backgroundColor: theme.palette.red60
            },
            ':active, &.Mui-active': {
              backgroundColor: theme.palette.red70
            },
            ':disabled': {
              color: theme.palette.white,
              backgroundColor: theme.palette.red20
            }
          }),
          ...(ownerState.color === 'secondary' && {
            backgroundColor: 'transparent',
            boxShadow: `inset 0 0 0 1.5px ${theme.palette.darkMode60}`,
            color: theme.palette.darkMode60,
            ':hover': {
              color: theme.palette.white,
              backgroundColor: theme.palette.darkMode60,
              boxShadow: `inset 0 0 0 1.5px ${theme.palette.darkMode60}`
            },
            ':active, &.Mui-active': {
              backgroundColor: theme.palette.darkMode40,
              boxShadow: `inset 0 0 0 1.5px ${theme.palette.darkMode40}`,
              color: theme.palette.white
            },
            ':disabled': {
              color: theme.palette.gray60,
              backgroundColor: 'transparent',
              boxShadow: `inset 0 0 0 1.5px ${theme.palette.gray60}`
            }
          }),
          ...(ownerState.color === 'tertiary' && {
            backgroundColor: theme.palette.gray10,
            color: theme.palette.darkMode60,
            ':hover': {
              color: theme.palette.white,
              backgroundColor: theme.palette.darkMode60
            },
            ':active, &.Mui-active': {
              backgroundColor: theme.palette.darkMode40,
              color: theme.palette.white
            },
            ':disabled': {
              backgroundColor: theme.palette.gray40,
              color: theme.palette.gray60
            }
          })
        };
      }
    }
  },
  MuiIconButton: {
    styleOverrides: {
      root: _ref4 => {
        let {
          theme
        } = _ref4;
        return {
          color: theme.palette.blue80
        };
      }
    }
  }
};

export { MuiButtonOverrides };
